import React from 'react';
import { compact } from 'lodash';
import classnames from 'classnames';

import Accordion from '../../Accordion';
import { RichTextField } from '../../RichTextField/RichTextField';
import { EnglishLevelsAccordionComponentFragment, EnglishLevelComponentFragment } from '../../../../graphql.schema';

import * as styles from './StrapiEnglishLevelsAccordion.module.scss';

const inlinedCertifications = (level: EnglishLevelComponentFragment) =>
  compact(level.certifications).map((c) => `${c.correspondingLevel}`);

const AccordionContent = (props: EnglishLevelComponentFragment) => {
  return (
    <div className={styles.content}>
      <div className={styles.infoBlocks}>
        {compact(props.information_blocks).map((data, i) => (
          <div key={`info-block-${i}`}>
            <h5 className="title is-5">{data.title}</h5>
            <RichTextField className={styles.text} content={data.content} />
          </div>
        ))}
      </div>
      {props.examples ? (
        <div className={styles.examplesColumn}>
          <h5 className={classnames('title is-5')}>{props.examples.title}</h5>
          <RichTextField className={styles.text} content={props.examples.content} />
        </div>
      ) : null}
    </div>
  );
};

export const StrapiEnglishLevelsAccordion = ({ englishLevelGroup }: EnglishLevelsAccordionComponentFragment) => {
  if (!englishLevelGroup) return null;
  const levels = englishLevelGroup.englishLevels;
  if (!levels) return null;
  return (
    <div className={classnames('EnglishLevelsAccordion--root', styles.root)}>
      <Accordion
        data={compact(levels).map((level) => ({
          title: `Wall Street English ${level?.name}`,
          rightTitleContent: inlinedCertifications(level),
          children: <AccordionContent {...level} />,
        }))}
      />
    </div>
  );
};
